
interface StockCategoryConfigCellDelegate
{
    addChildDidPress(cell:StockCategoryConfigCell, category:StockCategory):void;
    changeParentDidPress(cell:StockCategoryConfigCell, category:StockCategory):void;
}

class StockCategoryConfigCell extends UITableViewCell
{
    delegate:StockCategoryConfigCellDelegate|null = null;

    private nameTextField:MUITextField = null;
    private addChildButton:MUIButton = null;
    private changeParentButton:MUIButton = null;

    awakeFromHTML(){
        this.nameTextField = MUIOutlet(this, "name-tf", "MUITextField");
        this.nameTextField.setOnDidEndEditing(this, function(this:StockCategoryConfigCell, textfield:MUITextField, value:string){
            this.commitName(value);
        });
        this.nameTextField.setOnEnterPress(this, function(this:StockCategoryConfigCell, textfield:MUITextField, value:string){
            this.commitName(value);
        });

        this.addChildButton = MUIOutlet(this, 'add-child-btn', 'MUIButton');
        this.addChildButton.setAction(this, function(this:StockCategoryConfigCell){
            if (this.delegate != null) this.delegate.addChildDidPress(this, this._stockCategory);
        });

        this.changeParentButton = MUIOutlet(this, 'change-parent-btn', 'MUIButton');
        this.changeParentButton.setAction(this, function(this:StockCategoryConfigCell){
            if (this.delegate != null) this.delegate.changeParentDidPress(this, this._stockCategory);
        });
    }

    private _stockCategory:StockCategory = null;
    set item (item:StockCategory){
        if (item == null) return;

        this._stockCategory = item;
        this.nameTextField.text = item.name;
        this.nameTextField.layer.style.paddingLeft = ( item.indentLevel * 20 ) + "px";
    }

    // The name is required: an empty one puts the current name back
    private commitName(value:string){
        if (this._stockCategory == null) return;

        let name = value != null ? value.trim() : "";
        if (name.length == 0) {
            this.nameTextField.text = this._stockCategory.name;
            return;
        }
        if (name == this._stockCategory.name) return;

        this._stockCategory.name = name;
        DBHelper.saveMainContext();
    }

}
